import React from 'react';

import { CommonInputProps } from './FormInputInternals';
import { FormNumberInput } from './FormNumberInput';

interface FormPercentInputProps extends CommonInputProps {
    placeholder?: string;
    optional?: boolean;
}
export const FormPercentInput = (props: FormPercentInputProps) => {
    return (
        <FormNumberInput
            placeholder="37"
            {...props}
            isAllowed={({ floatValue = 0 }) => floatValue <= 100 && floatValue >= 0}
            allowNegative={false}
        />
    );
};
